var _rect, _path, _path2, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntegrationSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132,
    height: 118,
    fill: "none",
    viewBox: "0 0 132 118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 118,
    fill: "#F2F6FB",
    rx: 6.028,
    transform: "matrix(-1 0 0 1 132 0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#45985E",
    fillRule: "evenodd",
    d: "M65.696 72.802c-15.286 0-27.677-12.359-27.677-27.604S50.41 17.594 65.696 17.594s27.677 12.359 27.677 27.604-12.391 27.604-27.677 27.604z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M61.362 57.603L49.688 46.205l3.269-3.192 8.405 8.207 17.744-17.326 3.27 3.192-21.014 20.517z",
    clipRule: "evenodd"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 80.599,
    height: 4.853,
    fill: "#E1E5F0",
    rx: 1.959,
    transform: "matrix(-1 0 0 1 106.147 87.662)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationSuccess);
export default __webpack_public_path__ + "static/media/integration-success.8542f55a13c14c3235934ad0fa12a6a1.svg";
export { ForwardRef as ReactComponent };